<template>
  <div class="login">
    <header class="login-header"></header>
    <div class="login-content">
      <SignInWindow />
    </div>
  </div>
</template>

<script>
import SignInWindow from '../components/SignInWindow.vue';

export default {
  name: 'LoginView',
  components: { SignInWindow },
};
</script>
<style>
  .login-content
  {
   background-color: #efefef; 
  }
</style>